import { createFileRoute } from "@tanstack/react-router";
import Page from "@/app/auth/register/invite/page";

export const Route = createFileRoute("/auth/register/invite")({
  component: Page,
});
